import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const DownSvg = ({ dropDownStroke = '#44338A' }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1 1.50006L6.33333 6.83339L11.6667 1.50006"
                    stroke={dropDownStroke}
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1 1.5L9 9.5L17 1.5"
                    stroke={dropDownStroke}
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width={10} height={5} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m1 .5 4 4 4-4" stroke={dropDownStroke} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default DownSvg;
